<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <div class="locations-title">Events</div>

          <two-label-w-link
            :twoLines="true"
            link=""
            linkLabel=""
            firstLabel=""
            secondLabel=""
          />
          <div class="left">
            <a class="Twilight" href="#/Twilight"> </a>

            <u><strong>Twilight Nature Paddle</strong></u>
            <br /><br />
            Whether you’re an experienced paddler or complete beginner, join us and we’ll show you why these guided trips have become a customer favorite. Children welcome (minimum age 8 years; must be accompanied by an adult).
            <br /><br />
            <strong>
              From our Clark Park Boathouse. Seats limited. Contact us to reserve your single kayak, tandem kayak, or canoe. Let us know your preferred date and the number and type of boats required.
            </strong>
            <br /><br />
            Price: Single kayak—$45*; Tandem kayak or canoe—$65* <br>
<i class="small-note">*Plus 15% Chicago Entertainment Tax</i>

            <br /><br />
            
            <strong>Upcoming dates:</strong>
            <table class="upcoming-dates-table">
              <tbody>
                <tr>
                  <td>Saturday, <strong>June 13</strong> 5:30 p.m.</td>
                  <td>Saturday, <strong>June 27</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>July 11</strong> 6:00 p.m.</td>
                  <td>Saturday, <strong>July 25</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>August 8</strong> 6:00 p.m.</td>
                  <td>Saturday, <strong>August 22</strong> 6:00 p.m.</td>
                </tr>
                <tr>
                  <td>Saturday, <strong>September 5</strong> 6:00 p.m.</td>
                  <td>Saturday, <strong>September 12</strong> 5:30 p.m.</td>
                </tr>
              </tbody>
            </table>

 <div class="text-center">
  <br><br>
            <a class="btn-primary btn" href="#/GroupContact"
              ><strong>Contact</strong>
            </a>
          </div>

          </div>

         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwoLabelWLink from "../TwoLabelWLink";
export default {
  name: "Events",
  components: {
    TwoLabelWLink,
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.space {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.cell-bg-red {
  background-color: #f4cccc;
}

.cell-bg-green {
  background-color: #b6d7a8;
}

.cell-bg-blue {
  background-color: #cfe2f3;
}

.table-bordered th,
.table-bordered td {
  border-color: black;
  text-align: center;
}
.upcoming-dates-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}
.upcoming-dates-table td {
  color: black;
  padding: 0.4rem 0.8rem;
  text-align: left;
  vertical-align: top;
}
.upcoming-dates-table tr + tr td {
  padding-top: 0.75rem;
}
.left {
  text-align: left;
  /* font-weight: bolder; */
}
.blue {
  color: #007bff;
  font-weight: bolder;
}
.page {
  background-image: url("../../assets/kayak2.jpg");
  flex-direction: column;
}
.responsiveCal {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.responsiveCal iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.small-note {
  font-size: 0.85rem;
  font-style: italic;
}

.btn-primary {
  margin-top: -35px;
  margin-bottom: 2px;
  text-align: center;
  display: inline-block;
}
</style>
